import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';
import moment from 'moment';

@HookClass('webhook')
export class WebhookHook extends BaseHook {

    @Hook('6917a1a8-921f-4c9d-a542-a86892ebf414')
    public webhook(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://webhook.local.nickbuilder.com.br/api/process/start/new/client/default'
                            : 'https://webhook.fluna.io/api/process/start/new/client/default';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/8460e2ee-1e5b-4a85-8533-064e8efba1cb`,
                                params: {},
                                headers: {
                                    'nick-system': '925468af-4af9-4e78-b60d-8eb5cccd643d'
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

}
